import Axios from "../config/axios-v1-config";

// Contrato de prestación de servicios para repartidores.
// Servido por microservice-users (módulo driver-service-contracts), expuesto a
// través del proxy /users/* del bff-auth-gateway. El JWT lo inyecta el
// interceptor de Axios; el backend deriva la empresa logística desde el token.

const BASE = "users/service-contracts";

// ── Operador (empresa logística) ──────────────────────────────────────────────

// Historial de versiones de un tipo de documento (o de todos si no se pasa).
export const getContractHistory = (documentType, page = 1, limit = 50) => {
  const dt = documentType ? `&documentType=${documentType}` : "";
  return Axios.get(`${BASE}?page=${page}&limit=${limit}${dt}`);
};

// Sin documentType: todas las vigentes (una por tipo). Con: la de ese tipo.
export const getActiveContract = (documentType) => {
  const dt = documentType ? `?documentType=${documentType}` : "";
  return Axios.get(`${BASE}/active${dt}`);
};

export const uploadContractVersion = (
  file,
  { documentType, title, effectiveFrom, notes }
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (documentType) formData.append("documentType", documentType);
  formData.append("title", title);
  formData.append("effectiveFrom", effectiveFrom);
  if (notes) formData.append("notes", notes);
  return Axios.post(BASE, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Estado de firma de los repartidores para la versión vigente de un tipo.
export const getSignatoriesStatus = (documentType, page = 1, limit = 50) => {
  const dt = documentType ? `&documentType=${documentType}` : "";
  return Axios.get(
    `${BASE}/signatories-status?page=${page}&limit=${limit}${dt}`
  );
};

export const getContractSignatures = (templateId, page = 1, limit = 100) =>
  Axios.get(`${BASE}/${templateId}/signatures?page=${page}&limit=${limit}`);

// ── Editor de campos dinámicos (estilo DocuSign) ──────────────────────────────

// Bytes del PDF servidos por el backend (mismo origen + JWT) para renderizar con
// pdf.js sin problemas de CORS de S3.
export const getContractFile = (templateId) =>
  Axios.get(`${BASE}/${templateId}/file`, { responseType: "arraybuffer" });

export const getContractFieldLayout = (templateId) =>
  Axios.get(`${BASE}/${templateId}/field-layout`);

// fields: [{ key, type, label?, required?, fontSize?, align?, rect:{page,x,y,width,height} }]
export const saveContractFieldLayout = (templateId, fields) =>
  Axios.put(`${BASE}/${templateId}/field-layout`, { fields });

// Activa un borrador: lo marca vigente y archiva la versión anterior.
export const activateContract = (templateId) =>
  Axios.post(`${BASE}/${templateId}/activate`);
